export default "__VITE_ASSET__BAfJaZU8__"